import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';

@model.urnResource('relation_status')
@doc.path('/relation_statuses/{?id}')
export default class RelationStatusModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	get reference(): RelationStatusReference {
		return this.get('reference');
	}

	public getLabel(locale: 'en' | 'fr') {
		switch (this.reference) {
			case 'activated':
				return locale === 'en' ? 'activated' : 'activé';
			case 'deleted':
				return locale === 'en' ? 'deleted' : 'supprimée';
		}
	}

	public get color() {
		switch (this.reference) {
			case 'activated':
				return 'green';
			case 'deleted':
				return 'red';
		}
	}
}